import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router-dom";
import "assets/vendors/style";
import "styles/wieldy.less";
import configureStore, { history } from "./appRedux/store";
import App from "./containers/App/App";
import Context from "./Context";
import api from "./api/rest";
import userActions from "./appRedux/actions/User";
import wsClient from "./api/websocket";
import reportDownload from "./api/reportDownload";

const store = configureStore();

const cx = {
  api,
};

const userInit = () =>
  new Promise(() => {
    store.dispatch(userActions.authCheck());
  });

userInit();

// Регистрируем глобальный handler авто-скачивания DOCX/PDF при готовности
// report_ready. Сам connect делается ниже после получения accessToken.
reportDownload.register();

// Подключаемся к WS при наличии валидного token. Если token приходит позже
// (через token-exchange / парсинг hash при OAuth callback), переподключаемся
// по событию onTokenExchanged. WS-клиент сам управляет reconnect и
// re-subscription на сервере.
function tryConnectWs() {
  wsClient.connect();
}
tryConnectWs();
document.addEventListener("onTokenExchanged", tryConnectWs);

const ReactApp = () => (
  <Context.Provider value={cx}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </ConnectedRouter>
    </Provider>
  </Context.Provider>
);

export default ReactApp;
